export default __webpack_public_path__ + "static/media/avatars(4).d1551398.png";